module.exports = __webpack_public_path__ + "static/media/mode-13.0d616180.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-13.svg
// module id = 968
// module chunks = 2